import TableButton from "components/atoms/buttons/TableButton";
import React, { useState } from "react";
import AccountAccess from "pages/account/access";
import AccountInfoLabel from "components/atoms/text/labels/AccountInfoLabel";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { MdArrowForwardIos } from "react-icons/md";
import { AccountInfoList } from "pages/alert/view/AlertViewStyled";
import AccountId from "components/atoms/text/labels/AccountId";

export interface AccountAccessProps {
  buttonType: "Login As" | string | React.ReactNode;
  useTemporary: boolean;
  isShowOnlyUser: boolean;
  toPath?: string;
}

export default function useAccountAccess({
  buttonType,
  useTemporary,
  isShowOnlyUser,
  toPath,
}: AccountAccessProps) {
  const [isAccessModal, setIsAccessModal] = useState<null | string>(null);
  const [atTopLevel, setAtTopLevel] = useState<boolean>(false);
  const AccountAccessButton = ({
    accountId,
    accountNumber,
    accountName,
    index,
    level,
    useAtTopLevel = true,
  }: {
    accountId: string;
    accountNumber?: string;
    accountName?: string;
    index?: number;
    level?: LEVEL_TYPE;
    useAtTopLevel?: boolean;
  }) => {
    if (typeof buttonType === "string") {
      if (buttonType === "Login As") {
        return (
          <TableButton
            label="Login As"
            onClick={(e) => {
              e.stopPropagation();
              setIsAccessModal(accountId);
            }}
            data-testid={`account-access-login-as-${index}`}
          />
        );
      }
      if (buttonType === "RecorderAccountButton") {
        return (
          <AccountInfoList
            onClick={(e) => {
              e.stopPropagation();
              setIsAccessModal(accountId);
            }}
            data-testid="account-access-account-info-label"
          >
            {(index ?? 0) > 0 && <MdArrowForwardIos size={13} />}
            {accountName}
            {level === LEVEL_TYPE.EU && (
              <AccountId level={level} accountId={accountNumber ?? ""} />
            )}
          </AccountInfoList>
        );
      }
      if (buttonType === "AccountInfoLabel" && accountNumber && accountName) {
        return (
          <AccountInfoLabel
            level={level as LEVEL_TYPE}
            accountNumber={accountNumber}
            accountName={accountName}
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setIsAccessModal(accountId);
            }}
            data-testid="account-access-account-info-label"
          />
        );
      }
      return (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setAtTopLevel(index !== undefined && index === 0);
            setIsAccessModal(accountId);
          }}
          data-testid={`account-access-${index}`}
        >
          {buttonType}
        </button>
      );
    }
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsAccessModal(accountId);
        }}
        data-testid={`account-access-${buttonType}`}
      >
        {buttonType}
      </div>
    );
  };
  const AccountAccessModal =
    isAccessModal !== null ? (
      <AccountAccess
        accountId={isAccessModal as string}
        onModal={() => {
          setAtTopLevel(false);
          setIsAccessModal(null);
        }}
        useTemporary={useTemporary}
        isShowOnlyUser={isShowOnlyUser}
        toPath={toPath}
        atTopLevel={atTopLevel}
      />
    ) : null;
  return {
    isAccessModal,
    setIsAccessModal,
    AccountAccessButton,
    AccountAccessModal,
  };
}
